/**
 * Normalizes GET /admin/tracking-summaries response body (axios `response.data`).
 *
 * Supported shapes:
 * - { status, message, data: { trackingSummaries, pagination: { total, page, limit, totalPages }, summary? } }
 * - Legacy: { data: { trackingSummaries, total } } (total at data root)
 */
export function normalizeTrackingListResponse(apiBody) {
  const root =
    apiBody?.data != null && typeof apiBody.data === "object" && !Array.isArray(apiBody.data)
      ? apiBody.data
      : apiBody;

  const list = Array.isArray(root?.trackingSummaries) ? root.trackingSummaries : [];
  const pagination = root?.pagination;

  let total;
  if (pagination != null && pagination.total != null && pagination.total !== "") {
    total = Number(pagination.total);
  } else if (root?.total != null && root.total !== "") {
    total = Number(root.total);
  } else {
    total = list.length;
  }

  if (!Number.isFinite(total) || total < 0) {
    total = list.length;
  }

  return {
    trackingSummaries: list,
    total,
    pagination: pagination && typeof pagination === "object" ? pagination : null,
    summary: root?.summary ?? null,
  };
}
